import styled from 'styled-components';

export const Icons = styled.div`
  width: 45px;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background-color: var(--panel-bg-color);
`;

export const IconsSeparator = styled.div`
  width: 100%;
  height: 9px;
  display: flex;
  justify-content: center;
  align-items: center;

  opacity: 0.5;

  &::after {
    content: '';
    width: 33px;
    height: 1px;
    background-color: var(--text-color);
  }
`;

export const Item = styled.div`
  width: 45px;
  height: 45px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
